import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ValidationResultsVm } from './validation-results.model';
import { BehaviorSubject } from 'rxjs';
import { ValidationResultsPresenter } from './validation-results.presenter';
import { AsyncPipe } from '@angular/common';
import { JuiAlertBlock } from '@jump-tech-frontend/core-components-angular';
import { AnimatedBorderWrapperComponent } from './components/animated-border-wrapper/animated-border-wrapper.component';
import { ClassificationResult } from '@jump-tech-frontend/domain';
import { I18nKeys } from '@jump-tech-frontend/app-config';

@Component({
  selector: 'validation-results',
  imports: [AsyncPipe, JuiAlertBlock, AnimatedBorderWrapperComponent],
  templateUrl: 'validation-results.component.html',
  styleUrls: ['validation-results.component.scss'],
  providers: [ValidationResultsPresenter]
})
export class ValidationResultsComponent implements OnChanges {
  @Input() results: ClassificationResult;
  @Input() type: string;
  @Input() inProgress: boolean;
  @Input() i18ns: I18nKeys;
  vm$: BehaviorSubject<ValidationResultsVm> = new BehaviorSubject<ValidationResultsVm>(null);

  constructor(private presenter: ValidationResultsPresenter) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['i18ns']) {
      this.presenter.setI18ns(this.i18ns);
    }
    this.presenter.load(this.vm$, this.results, this.type, this.inProgress);
  }
}
